import React, {
    useEffect, useRef, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const ModalDeleteProfile = ({ isOpenModal, setIsOpenModal, deleteProfile }) => {
    const modalRef = useRef(null);
    const cancelButtonRef = useRef(null);

    const handleClose = useCallback(() => {
        setIsOpenModal(false);
    }, [setIsOpenModal]);

    const handleKeyDown = useCallback(
        (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        },
        [handleClose],
    );

    const handleClickOutside = useCallback(
        (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                handleClose();
            }
        },
        [handleClose],
    );

    useEffect(() => {
        if (isOpenModal) {
            document.addEventListener('keydown', handleKeyDown);

            document.addEventListener('mousedown', handleClickOutside);

            cancelButtonRef.current?.focus();
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);

            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenModal, handleKeyDown, handleClickOutside]);

    if (!isOpenModal) return null;

    return (
        <div
            ref={modalRef}
            className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50"
            role="dialog"
            aria-modal="true"
        >
            <div
                className="tw-bg-white tw-shadow-xl tw-w-full tw-max-w-lg tw-min-h-72 tw-p-6 tw-animate-fadeIn"
            >
                <div className="tw-flex tw-justify-end">
                    <button type="button" onClick={handleClose}>
                        <FontAwesomeIcon icon={faXmark} width={20} height={16} />
                    </button>
                </div>
                <div className="tw-my-8 md:tw-px-10">
                    <h2 className="tw-text-xl md:tw-text-3xl tw-font-semibold tw-text-center tw-mb-2">Excluir Conta</h2>
                    <p className="tw-text-gray-600 tw-text-center tw-m-0">
                        Tem certeza de que deseja excluir sua conta?
                    </p>
                    <p className="tw-text-gray-600 tw-text-center ">
                        Essa ação é permanente e não poderá ser desfeita.
                    </p>
                </div>

                <div className="tw-flex tw-justify-between tw-gap-4 md:tw-px-10">
                    <button
                        type="button"
                        ref={cancelButtonRef}
                        onClick={handleClose}
                        className="tw-w-full tw-py-2 tw-px-4 tw-bg-[#252D38] tw-text-white"
                    >
                        Voltar
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            deleteProfile();

                            handleClose();
                        }}
                        className="tw-w-full tw-py-2 tw-px-4 tw-bg-red-600 tw-text-white"
                    >
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    );
};

ModalDeleteProfile.propTypes = exact({
    isOpenModal: PropTypes.bool.isRequired,
    setIsOpenModal: PropTypes.func.isRequired,
    deleteProfile: PropTypes.func.isRequired,
});

export default ModalDeleteProfile;
